<script async src="https://www.tiktok.com/embed.js"></script>

<template>
  <timeline-step
    :ref="`step-${step.id}`"
    :step="step"
    :dusk="`timeline-step-${step.id}`"
    @toggleStep="toggleStep(step.id)"
  >
    <div v-if="joined && hasApprovedContent">
      <div v-if="deliverablesLeftToPost.length > 0" class="mt-2">
        Waiting for you to post:
        <strong>
          <span v-if="storiesRequired > 0">{{
            instagramStories ? inputStories.length - instagramStories.length : storiesRequired
          }}</span>
          <span v-if="postsRequired > 0">{{
            instagramMedia ? inputPosts.length - instagramMedia.length : postsRequired
          }}</span>
          <span v-if="reelsRequired > 0">{{
            instagramReels ? inputReels.length - instagramReels.length : reelsRequired
          }}</span>
          <span v-if="youtubeShortsRequired > 0">{{
            youtubeShorts ? inputShorts.length - youtubeShorts.length : youtubeShortsRequired
          }}</span>
          {{ deliverablesLeftToPost.join(', ') }}
        </strong>
      </div>
      <div>
        <div v-if="hasInstagramDeliverables">
          <div v-if="campaignShouldDeliver('instagram_story')">
            <div class="mt-4 sub-heading text-lg">
              Instagram Stories <span v-if="hasPostedDeliverable('instagram_story', instagramStories)">✅</span>
            </div>
            <div class="mt-1">
              Enter below the link of the post:
              <div v-for="(story, index) in inputStories" :key="index" class="flex items-center">
                <input
                  v-model="story.value"
                  type="text"
                  class="text-sm"
                  placeholder="https://instagram.com/stories/adoreme/3003484986076080374/"
                  :readonly="!story.enabled"
                  :class="{ 'cursor-not-allowed': !story.enabled }"
                />
                <button
                  v-promise-btn="{ disableBtn: !story.enabled }"
                  :class="{ 'btn-disabled cursor-not-allowed opacity-50': !story.enabled }"
                  class="ml-1 button button-primary"
                  :disabled="!story.enabled"
                  @click="submitLink('instagram_story', story.value)"
                >
                  <svg-vue icon="paper-airplane" class="h-4 inline-block text-white transform rotate-90" />
                </button>
              </div>
            </div>
            <div class="mt-2 grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-4">
              <div v-for="(media, index) in instagramStories" :key="index">
                <a :href="media.permalink" target="_blank">
                  <img class="max-w-full" :src="media.media_url" />
                </a>
              </div>
            </div>
          </div>
          <div v-if="campaignShouldDeliver('instagram_post')">
            <div class="mt-2 sub-heading text-lg">
              Instagram Posts
              <span v-if="instagramMedia ? inputPosts.length - instagramMedia.length === 0 : false">✅</span>
            </div>
            <div class="mt-1">
              Enter below the link of the post:
              <div v-for="(post, index) in inputPosts" :key="index">
                <div v-if="!post.processing" class="flex items-center">
                  <input
                    v-model="post.value"
                    type="text"
                    class="text-sm"
                    placeholder="https://www.instagram.com/p/COTS1XLnQIu"
                    :readonly="!post.enabled"
                    :class="{ 'cursor-not-allowed': !post.enabled, 'border-green-600': post.successful }"
                  />
                  <button
                    v-if="!post.successful"
                    v-promise-btn="{ disableBtn: !post.enabled }"
                    :class="{ 'btn-disabled cursor-not-allowed opacity-50': !post.enabled }"
                    class="ml-1 button button-primary"
                    :disabled="!post.enabled"
                    @click="submitLink('instagram_post', post.value)"
                  >
                    <svg-vue icon="paper-airplane" class="h-4 inline-block text-white transform rotate-90" />
                  </button>
                </div>
                <div v-if="post.processing" class="flex items-center mt-2 space-x-2 text-lg">
                  <LoadingSpinner />
                  <span>Your post is currently being processed...</span>
                </div>
              </div>
            </div>
            <div class="mt-2 grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-4">
              <div v-for="(media, index) in instagramMedia" :key="index">
                <a :href="media.permalink" target="_blank">
                  <img class="max-w-full" :src="media.media_url" />
                </a>
              </div>
            </div>
            <div v-if="failedInstagramMedia.length > 0">
              <div class="my-2">
                {{ failedLinks }}
              </div>
              <div v-for="(media, index) in failedInstagramMedia" :key="index">
                <div class="flex items-center">
                  <input
                    v-model="media.permalink"
                    type="text"
                    class="text-sm cursor-not-allowed border-red-600"
                    placeholder="https://www.instagram.com/p/COTS1XLnQIu"
                    readonly
                  />
                </div>
              </div>
            </div>
          </div>
          <div v-if="optionalReels || campaignShouldDeliver('reels')">
            <div v-if="optionalReels" class="mt-4 sub-heading text-lg">
              Chose to do a Reel instead? Drop the link below
            </div>
            <div v-else-if="campaignShouldDeliver('reels')" class="mt-4 sub-heading text-lg">
              Reels <span v-if="instagramReels ? inputReels.length - instagramReels.length === 0 : false">✅</span>
            </div>
            Enter below the links of the posted videos:
            <div v-for="(reel, index) in inputReels" :key="index" class="flex items-center">
              <input
                v-model="reel.value"
                type="text"
                class="text-sm"
                placeholder="https://www.instagram.com/reel/COTS1XLnQIu"
                :readonly="!reel.enabled"
                :class="{ 'cursor-not-allowed': !reel.enabled, 'border-green-600': reel.successful }"
              />
              <button
                v-if="!reel.successful"
                v-promise-btn="{ disableBtn: !reel.enabled }"
                :class="{ 'btn-disabled cursor-not-allowed opacity-50': !reel.enabled }"
                class="ml-1 button button-primary"
                :disabled="!reel.enabled"
                @click="submitLink('reels', reel.value)"
              >
                <svg-vue icon="paper-airplane" class="h-4 inline-block text-white transform rotate-90" />
              </button>
            </div>
            <div v-if="failedInstagramReels.length > 0">
              <div class="my-2">
                {{ failedLinks }}
              </div>
              <div v-for="(media, index) in failedInstagramReels" :key="index">
                <div class="flex items-center">
                  <input
                    v-model="media.permalink"
                    type="text"
                    class="text-sm cursor-not-allowed"
                    placeholder="https://www.instagram.com/reel/COTS1XLnQIu"
                    readonly
                  />
                </div>
              </div>
            </div>
          </div>
          <div v-if="campaignShouldDeliver('igtv')">
            <div class="mt-4 sub-heading text-lg">
              IGTV <span v-if="hasPostedDeliverable('igtv', instagramIgtv)">✅</span>
            </div>
            <div class="mt-1">
              Enter below the link of the posted video:
              <div class="flex items-center">
                <input
                  v-model="temporaryIgtvLink"
                  type="text"
                  class="text-sm"
                  placeholder="https://www.instagram.com/p/COTS1XLnQIu"
                />
                <button v-promise-btn class="ml-1 button button-primary" @click="submitLink('igtv', temporaryIgtvLink)">
                  <svg-vue icon="paper-airplane" class="h-4 inline-block text-white transform rotate-90" />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="campaignShouldDeliver('youtube_shorts')">
          <div class="mt-1 lg:w-1/2 w-full">
            <div class="mt-4 sub-heading text-lg">
              Youtube <span v-if="hasPostedDeliverable('youtube_shorts', youtubeShorts)">✅</span>
            </div>
            Enter below the links of the posted videos:
            <div v-for="(short, index) in inputShorts" :key="index" class="flex flex-col justify-between">
              <div class="flex items-center">
                <input
                  v-model="short.value"
                  type="text"
                  class="text-sm"
                  placeholder="https://www.youtube.com/shorts/COTS1XLnQIu"
                  :readonly="!short.enabled"
                  :class="{ 'cursor-not-allowed': !short.enabled }"
                />
                <button
                  v-promise-btn="{ disableBtn: !short.enabled }"
                  :class="{ 'btn-disabled cursor-not-allowed opacity-50': !short.enabled }"
                  class="ml-1 button button-primary"
                  :disabled="!short.enabled"
                  @click="submitLink('youtube_shorts', short.value)"
                >
                  <svg-vue icon="paper-airplane" class="h-4 inline-block text-white transform rotate-90" />
                </button>
              </div>
              <a :href="short.value" class="my-4" target="_blank">
                <img :src="youtubeThumbnail(short.value)" />
              </a>
            </div>
          </div>
        </div>
        <div v-if="campaignShouldDeliver('youtube_video')">
          <div v-if="postedDeliverables.youtubeLink" class="mt-1 lg:w-1/2 w-full">
            <div class="mt-4 sub-heading text-lg">
              Youtube <span v-if="hasPostedDeliverable('youtube_video', youtubePosts)">✅</span>
            </div>
            <a :href="postedDeliverables.youtubeLink" target="_blank">
              <img :src="youtubeThumbnail(postedDeliverables.youtubeLink)" />
            </a>
          </div>
        </div>
        <div v-if="campaignShouldDeliver('tiktok_video')">
          <div class="mt-4 sub-heading text-lg">
            TikTok <span v-if="hasPostedDeliverable('tiktok_video', tikTokPosts)">✅</span>
          </div>
          <div class="mt-1">
            Enter below the link of the posted video:
            <div class="flex items-center">
              <input
                v-model="temporaryTikTokLink"
                type="text"
                class="text-sm"
                placeholder="https://www.tiktok.com/@remibader/video/6935946287946714374"
              />
              <button
                v-promise-btn
                class="ml-1 button button-primary"
                @click="submitLink('tiktok_video', temporaryTikTokLink)"
              >
                <svg-vue icon="paper-airplane" class="h-4 inline-block text-white transform rotate-90" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else-if="applied"
      class="block mt-4 py-3 px-4 uppercase text-center text-white mb-4 bg-green-600 font-bold text-sm"
    >
      Thank you for your application. We will review it and get back to you soon.
    </div>
    <div
      v-else-if="joined"
      class="block mt-4 py-3 px-4 uppercase text-center text-white mb-4 bg-green-600 font-bold text-sm"
    >
      {{ beforeUploadMessage }}
    </div>
    <div
      v-else-if="!joined && !applied && !campaignApplyByPassed"
      class="block mt-4 py-3 px-4 uppercase text-center text-white mb-4 bg-green-600 font-bold text-sm"
    >
      Apply to the campaign using the "Join campaign" button
    </div>
    <div
      v-else-if="!joined && !applied && campaignApplyByPassed"
      class="block mt-4 py-3 px-4 uppercase text-center text-white mb-4 bg-gray-600 font-bold text-sm"
    >
      Applications are closed
    </div>
  </timeline-step>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import URI from 'urijs';
import { Bus } from '../../bus';
import { youtubeId } from '../../helpers';
import LoadingSpinner from '../LoadingSpinner.vue';

export default {
  components: {
    LoadingSpinner,
  },
  data() {
    return {
      inputReels: [],
      inputPosts: [],
      inputStories: [],
      inputShorts: [],
      temporaryTikTokLink: '',
      temporaryIgtvLink: '',
      temporaryIgPostLink: '',
      isSubmitted: false,
    };
  },
  props: ['step'],
  computed: {
    ...mapState('timeline', ['campaign', 'campaignApplication', 'postedDeliverables']),
    ...mapGetters('timeline', [
      'reelsRequired',
      'postsRequired',
      'storiesRequired',
      'youtubeShortsRequired',
      'applied',
      'joined',
      'orderPlaced',
      'campaignShouldDeliver',
      'hasApprovedContent',
      'failedInstagramMedia',
      'failedInstagramReels',
      'instagramMedia',
      'instagramPosts',
      'instagramStories',
      'instagramReels',
      'instagramIgtv',
      'tikTokPosts',
      'youtubeShorts',
      'hasInstagramDeliverables',
      'hasPostedDeliverable',
      'deliverablesLeftToPost',
      'campaignApplyByPassed',
    ]),
    failedLinks() {
      return 'The links you manually submitted below and those we automatically found could not be matched. Please double-check to see if you tagged Adore Me (@adoreme) in your post; if not, feel free to update it. Also, ensure that you submitted the correct link(s) for this campaign. If none of these apply, get in touch with us via campaign chat so we can help you further.';
    },
    beforeUploadMessage() {
      if (this.campaign.review_content) {
        return '🎁 After your uploaded content gets approved, please post on the required social media channels. It might take up to one hour after posting until the campaign is closed so you can join other campaigns.';
      }

      return '🎁 After you upload the content, please post on the required social media channels. It might take up to one hour after posting until the campaign is closed so you can join other campaigns.';
    },
    optionalReels() {
      return this.campaignShouldDeliver('instagram_post') && !this.campaignShouldDeliver('reels');
    },
    requiresInstagramConnection() {
      if (
        this.campaignShouldDeliver('instagram_story') ||
        this.campaignShouldDeliver('instagram_post') ||
        this.campaignShouldDeliver('reels')
      ) {
        return true;
      }
      return false;
    },
  },
  watch: {
    campaign() {
      this.initializePostsInputs();
      this.initializeReelsInputs();
      this.initializeStoriesInputs();
      this.initializeYoutubeShortsInputs();
    },
    tikTokPosts() {
      if (this.tikTokPosts && this.tikTokPosts.length > 0) this.temporaryTikTokLink = this.tikTokPosts[0].permalink;
    },
    instagramIgtv() {
      if (this.instagramIgtv && this.instagramIgtv.length > 0) this.temporaryIgtvLink = this.instagramIgtv[0].permalink;
    },
  },
  methods: {
    ...mapMutations('timeline', ['setTikTokPosts', 'setInstagramPosts', 'setYoutubePosts', 'markStepCompleted']),
    initializeReelsInputs() {
      // if the reels are required I need to -1 for the array key to work
      // if the reels are optional then I need to give it a value because otherwise there will be no input
      let total = this.reelsRequired - 1;

      if (this.optionalReels) {
        total = 0;
      }

      if (!this.instagramReels) {
        return;
      }

      for (let i = 0; i <= total; i++) {
        this.inputReels.push({
          value: this.instagramReels[i]?.permalink,
          processing: this.instagramReels[i]?.matching_status === 'processing' ? true : false,
          successful: this.instagramReels[i]?.matching_status === 'success' ? true : false,
          enabled: !this.instagramReels[i]?.matching_status ? true : false,
        });
      }
    },
    initializePostsInputs() {
      let total = this.postsRequired - 1;

      if (!this.instagramMedia) {
        return;
      }

      for (let i = 0; i <= total; i++) {
        this.inputPosts.push({
          value: this.instagramMedia[i]?.permalink,
          processing: this.instagramMedia[i]?.matching_status === 'processing' ? true : false,
          successful: this.instagramMedia[i]?.matching_status === 'success' ? true : false,
          enabled: !this.instagramMedia[i]?.matching_status ? true : false,
        });
      }
    },
    initializeStoriesInputs() {
      let total = this.storiesRequired - 1;

      if (!this.instagramStories) {
        return;
      }

      for (let i = 0; i <= total; i++) {
        this.inputStories.push({
          value: this.instagramStories[i]?.permalink,
          enabled: this.instagramStories[i]?.permalink ? false : true,
        });
      }
    },
    initializeYoutubeShortsInputs() {
      let total = this.youtubeShortsRequired - 1;

      const computeLink = (id) => `https://youtube.com/shorts/${id}`;

      for (let i = 0; i <= total; i++) {
        if (this.youtubeShorts) {
          this.inputShorts.push({
            value: this.youtubeShorts[i]?.youtube_id ? computeLink(this.youtubeShorts[i]?.youtube_id) : null,
            enabled: this.youtubeShorts[i]?.youtube_id ? false : true,
          });
        } else {
          this.inputShorts.push({
            value: '',
            enabled: true,
          });
        }
      }
    },
    youtubeId,
    youtubeThumbnail(youtubeLink) {
      const youtubeId = this.youtubeId(youtubeLink);

      if (!youtubeId) {
        return null;
      }

      return `https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`;
    },
    checkLinkHostname(link, hostname) {
      link = URI(link).absoluteTo('https://').toString();
      const result = URI.parse(link);

      if (result && result.hostname && result.hostname.includes(hostname)) return true;

      return false;
    },
    async submitLink(deliverable, publishedLink) {
      if (this.isSubmitted) {
        return;
      }

      if (!publishedLink) {
        Bus.$emit('error', 'You cannot submit an empty link.');
        return;
      }

      this.isSubmitted = true;

      let youtubeId;
      let channel;

      if (deliverable === 'tiktok_video') {
        channel = 'tiktok';
        publishedLink = publishedLink.split('?')[0];
      } else if (deliverable === 'youtube_shorts') {
        channel = 'youtube';
        youtubeId = this.youtubeId(publishedLink);
      } else {
        channel = 'instagram';
        publishedLink = publishedLink.split('?')[0];
      }

      if (!this.checkLinkHostname(publishedLink, channel)) {
        Bus.$emit('error', 'The link is not valid');

        this.isSubmitted = false;

        return;
      }

      if (
        channel === 'instagram' &&
        this.instagramReels &&
        this.instagramReels.some((reel) => reel.permalink === publishedLink)
      ) {
        Bus.$emit('error', 'You have already submitted this link');

        this.isSubmitted = false;

        return;
      }

      if (
        channel === 'instagram' &&
        this.instagramMedia &&
        this.instagramMedia.some((post) => post.permalink === publishedLink)
      ) {
        Bus.$emit('error', 'You have already submitted this link');

        this.isSubmitted = false;

        return;
      }

      if (
        channel === 'instagram' &&
        this.instagramStories &&
        this.instagramStories.some((story) => story.permalink === publishedLink)
      ) {
        Bus.$emit('error', 'You have already submitted this link');

        this.isSubmitted = false;

        return;
      }

      if (
        channel === 'youtube' &&
        this.youtubeShorts &&
        this.youtubeShorts.some((short) => `https://youtube.com/shorts/${short.youtube_id}` === publishedLink)
      ) {
        Bus.$emit('error', 'You have already submitted this link');

        this.isSubmitted = false;

        return;
      }

      const { data } = await window.axios.post(`/campaign-applications/${this.campaignApplication.id}/submit-link`, {
        deliverable,
        publishedLink,
        youtubeId,
      });

      if (data && data.success) {
        if (data.tikTokPosts) {
          this.setTikTokPosts(data.tikTokPosts);
        }
        if (data.instagramPosts) {
          this.setInstagramPosts(data.instagramPosts);

          this.inputStories.forEach((story) => {
            if (story.value && story.value === publishedLink) {
              story.enabled = false;
            }
          });
        }
        if (data.youtubePosts) {
          this.setYoutubePosts(data.youtubePosts);

          this.inputShorts.forEach((short) => {
            if (short.value) {
              short.enabled = false;
            }
          });
        }

        if (
          data.campaign_application.status === 'pending_payment' ||
          data.campaign_application.status === 'completed'
        ) {
          this.markStepCompleted(this.step.id);
        }
      }

      this.isSubmitted = false;
    },
  },
};
</script>
